import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GoalsAndObjectivesResponse } from "@/core/types";

import { getGoalsAndObjectives } from "../queryFunctions/getGoalsAndObjectives";
import { memberCarePlanKeys } from "../keyFactory";

type UseGoalsAndObjectivesProps<TData = GoalsAndObjectivesResponse> = {
  patientId: string;
  select?: (data: GoalsAndObjectivesResponse) => TData;
};

type GoalsAndObjectivesQueryOptions = UseQueryOptions<
  GoalsAndObjectivesResponse,
  unknown,
  GoalsAndObjectivesResponse,
  ReturnType<typeof memberCarePlanKeys.goalsAndObjectives>
>;

export function useGoalsAndObjectives<TData = GoalsAndObjectivesResponse>({
  patientId,
  select,
}: UseGoalsAndObjectivesProps<TData>) {
  return useQuery({
    ...optionFactory(patientId),
    select,
  });
}

function optionFactory(patientId: string) {
  return {
    queryFn: () => getGoalsAndObjectives(patientId),
    queryKey: memberCarePlanKeys.goalsAndObjectives(patientId),
  } satisfies GoalsAndObjectivesQueryOptions;
}
